module.exports = __webpack_public_path__ + "assets/img/2fa0-ki.svg";